import { COLUMNS_UNMOUNT_GRID } from "../actionTypes";

export const updateArrDraggedColumns = (payload, isdataArray = false) => (dispatch, getState) => {
    if (!isdataArray) {
        const arrColumnMoviedTypes = getState().columns.arrColumnMoviedTypess;
        let newArrColumnMovedTypes = Object.assign([], arrColumnMoviedTypes);
        let nIndex = newArrColumnMovedTypes?.findIndex((eachColumn) => eachColumn.viewType === payload.viewType);
        if (nIndex === -1) {
            newArrColumnMovedTypes.push(payload);
        } else if (nIndex > -1) {
            newArrColumnMovedTypes[nIndex] = payload;
        }
        dispatch(updateCurrentColumnMovingState([...newArrColumnMovedTypes]));
    } else {
        dispatch(updateCurrentColumnMovingState(payload));
    }

};


export const updateCurrentColumnMovingState = (payload) => {
    return { type: COLUMNS_UNMOUNT_GRID.UPDATE_ARR_COLUMNS_UNMOUNT, payload };
};